import { apiPost, apiGet } from "../../utils"

export function getCreatedPromotionsAPI(data) {
    return apiGet(`/api/getCreatedPromotions`, data)
}